module.exports = __webpack_public_path__ + "img/names_screenshot.12858d73.jpg";